import {useEffect, useState} from "react";
import styles from "./Styles/Account.module.css";
import Select, { components } from "react-select";
import { Input, message, Button } from "antd";
import APIService from "../../Service/APIService";
import FailureIcon from "../../icons/failure-icon";
import Text from "../../common/typography/text";
import axios from 'axios';

// const accountOptions = [
//   { label: "Clinic A", value: "Clinic A" },
//   { label: "Clinic B", value: "Clinic B" },
// ];


export default function Account({ formData, setFormData }) {
  const [showLoader, setShowLoader] = useState(false);
  const [accountOptions, setAccountOptions] = useState([]);
  const [placeOptions, setPlaceOptions] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);

  const normalizeAccountOption = (account) => {
    if (!account) return account;
    const data = account.dataValues || account;
    return {
      ...account,
      ...data,
      label: account.label ?? data.label ?? data.AccountName ?? "",
      value: account.value ?? data.value ?? data.ID ?? "",
    };
  };

  const getOptions = async () => {
    const serv = new APIService();
    const resp = await serv.getDataFromBackend("/ivr/getivrformoptions");
    const data = resp?.data?.data ?? resp?.data ?? {};

    setAccountOptions((data.accounts || []).map(normalizeAccountOption));
    setPlaceOptions(data.placesOfService || []);
  }

  useEffect(() => {
    getOptions();
  }, []);

  const getProductOptions = async (accountId) => {
    if (!accountId) return;
    const serv = new APIService();
    const resp = await serv.getDataFromBackend(`/ivr/AddIVRProductFormOptions?accountId=${accountId}`);
    const data = resp?.data?.data ?? resp?.data ?? {};
    setFormData((prev) => ({
      ...prev,
      productGroupOptions: data.productGroups || [],
    }));
  }

  const [showBAAModal, setShowBAAModal] = useState(false);

  const handleAccountChange = async (val) => {
    console.log("Selected account option:", val);
    const selected = val ? normalizeAccountOption(val) : null;
    const selectedData = selected || {};

    if (selected?.BAA === false) {
      // fetch parent account
      const serv = new APIService();
      if (selected?.IsChildAccount) {
        const parentResp = await serv.getDataFromBackend(
          `getaccountbyid?ID=${selected?.ParentAccountID}`
        );
        console.log("Parent account response:", parentResp);
        // console.log("Parent Account Data: ", parentResp?.data?.data);
        if (parentResp?.data?.data?.BAA === false) {

          setShowBAAModal(true);
          // setAccBaaStatus(parentResp?.data?.data?.BAA);
        }
        else{
          setShowBAAModal(false);
        }
      } else {
        console.log("Selected account does not have a BAA and is not a child account.");
        setShowBAAModal(true);
        // setAccBaaStatus(selected?.BAA);
      }
    }
    else{
      setShowBAAModal(false);
    }

    setSelectedAccount(selected);
    // setShowBAAModal(false);
    console.log("Selected account data:", selectedData);
    setFormData((prev) => ({
      ...prev,
      accountName: selectedData.label ?? selectedData.AccountName ?? "",
      accountId: selectedData.value ?? selectedData.ID ?? "",
      distributorName: selectedData.DistributorName ?? "",
      distributorId: selectedData.DistributorID ?? null,
      addressLine1: selectedData.AddressLine1 ?? "",
      addressLine2: selectedData.AddressLine2 ?? "",
      city: selectedData.City ?? "",
      state: selectedData.State ?? "",
      zip: selectedData.Zip ?? "",
      phone: selectedData.Phone ?? "",
      fax: selectedData.Fax ?? "",
      // distributorUsername: selectedData.DistributorUsername ?? "",
      medicareContractor: selectedData.MedicareAdminContractor ?? "",
      npi: selectedData.NPI ?? "",
      tin: selectedData.TIN ?? "",
      ptan: selectedData.PTAN ?? "",
      distributorUserId: selectedData.DistributorUserID ?? "",
      distributorUsername: selectedData.DistributorUsername ?? "",
    }));
    getProductOptions(selectedData.value ?? selectedData.ID);
  };

  const downloadBAAForm = async () => {
      setShowLoader(true);
      const apiServe = new APIService();
      const sasUrl = await apiServe.getSasToken(
        "Resources/AdvancedSolutionBAA.pdf"
      );
  
      const exists = await apiServe.checkBlobExists(sasUrl);
      if (!exists) {
        message.error("File does not exist.");
        setShowLoader(false);
        return;
      }
  
      try {
        const response = await axios.get(sasUrl, {
          responseType: "blob",
        });
  
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
  
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "AdvancedSolutionBAA.pdf"); // specify file name and extension
        document.body.appendChild(link);
        link.click();
        link.remove();
  
        window.URL.revokeObjectURL(url); // clean up
      } catch (error) {
        message.error("Error downloading file.");
        console.error(error);
      } finally {
        setShowLoader(false);
      }
    };
    useEffect(() => {}, [showBAAModal]);

  return (
    <div className={styles.accountSection}>
      <h2 className={styles.sectionTitle}>ACCOUNT DETAILS</h2>

      <div className={styles.field}>
        <label className="form-label">
          Account Name <span style={{ color: "red" }}>*</span>
        </label>
        <Select
          options={accountOptions}
          placeholder="Account Name"
          value={
            selectedAccount ||
            accountOptions.find((opt) =>
              (formData.accountId && opt.value === formData.accountId) ||
              opt.label === formData.accountName
            ) ||
            null
          }
          onChange={handleAccountChange}
          styles={{
            container: (provided) => ({ ...provided, width: "240px" }),
            control: (provided) => ({
              ...provided,
              minHeight: 40,
              borderRadius: 4,
              borderColor: "#bebebe",
              padding: "0 8px",
              fontSize: 14,
            }),
            valueContainer: (provided) => ({ ...provided, padding: "0" }),
            input: (provided) => ({ ...provided, margin: 0, padding: 0 }),
            placeholder: (provided) => ({ ...provided, color: "#a0a0a0" }),
          }}
        />
      </div>
      {showBAAModal &&
        <div className="modal-warning-container-ivr">
          <FailureIcon
            className="warning-icon-container"
            width={16}
            height={16}
          />
          <Text>
            Our records indicate that we do not have a BAA form for your account. In order to submit an IVR request, you need to fill and send the BAA form to <a href="mailto:support@advancedsolution.health">support@advancedsolution.health</a>. Please download the form using the button below.
          </Text>
          <Button
            type="primary"
            onClick={() => downloadBAAForm()}
            style={{
              background: "#27a907",
              fontSize: "14px",
              fontWeight: "600",
              maxWidth: "fit-content",
            }}
          >
            Download
          </Button>
        </div>
      }
      {!showBAAModal &&
        <>
          <div className={styles.row2}>
            <div className={styles.field}>
              <label className="form-label">
                Place Of Service <span style={{ color: "red" }}>*</span>
              </label>
              <Select
                options={placeOptions}
                value={
                  placeOptions.find(
                    (opt) => opt.label === formData.placeOfService
                  ) || null
                }
                onChange={(val) =>
                  setFormData({ ...formData, placeOfService: val.label })
                }
                placeholder="Choose place Of Service"
                styles={{
                  container: (provided) => ({ ...provided, width: "100%" }),
                  control: (provided) => ({
                    ...provided,
                    minHeight: 40,
                    borderRadius: 4,
                    borderColor: "#bebebe",
                    padding: "0 8px",
                    fontSize: 14,
                  }),
                  valueContainer: (provided) => ({ ...provided, padding: "0" }),
                  input: (provided) => ({ ...provided, margin: 0, padding: 0 }),
                  placeholder: (provided) => ({ ...provided, color: "#a0a0a0" }),
                }}
              />
            </div>

            <div className={styles.field}>
              <label className="form-label">
                Provider Name <span style={{ color: "red" }}>*</span>
              </label>
              <Input
                className={styles.input}
                placeholder="Enter name"
                value={formData.physicianName || ""}
                onChange={(e) =>
                  setFormData({ ...formData, physicianName: e.target.value })
                }
              />
            </div>
          </div>

          <div className={styles.MedicareRow}>
            <label className="form-label">Medicare Admin Contractor</label>
            <Input
              placeholder="Enter contractor name"
              value={formData.medicareContractor || ""}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  medicareContractor: e.target.value,
                })
              }
            />
          </div>

          <div className={styles.row3}>
            <div className={styles.field}>
              <label className="form-label">NPI</label>
              <Input
                placeholder="XXXXXXXXXX"
                value={formData.npi || ""}
                onChange={(e) => setFormData({ ...formData, npi: e.target.value })}
              />
            </div>
            <div className={styles.field}>
              <label className="form-label">TIN</label>
              <Input
                placeholder="XX-XXXXXXX"
                value={formData.tin || ""}
                onChange={(e) => setFormData({ ...formData, tin: e.target.value })}
              />
            </div>
            <div className={styles.field}>
              <label className="form-label">PTAN</label>
              <Input
                placeholder="XX-XXXX"
                value={formData.ptan || ""}
                onChange={(e) => setFormData({ ...formData, ptan: e.target.value })}
              />
            </div>
          </div>
        </>
      }
    </div>
  );
}
